import i18next from "i18next";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { ModalComponent, SelectComponent } from "../../ui";
import { copyToClipboard, getCityName, htmlToPlainText, sanitizeHtml } from "../../../utils";
import {
  CopyRulesButton,
  RulesAccordion,
  RulesAccordionContent,
  RulesAccordionTitle,
  RulesAccordionToggleButton,
  RulesToolbar,
  SelectRoutes,
  StyledPaper,
  Wrapper,
} from "./style";
import classNames from "classnames";
import { BiCheck, BiChevronDown, BiCopy } from "react-icons/bi";

const RulesModalComponent = ({ fareRules, included, routes, actualSegment, openModal, handleCloseModal }) => {
  const { t, language } = i18next;

  let segment = actualSegment;

  if (!actualSegment) {
    segment = routes[0].segments[0];
  }

  const { fare_code, departure } = segment;
  const departureDate = departure.time.split(" ");
  const fareCodeDefaultKey = fare_code + "|" + _.first(departureDate) + "|" + segment.index;

  const [fareCodeKey, setFareCodeKey] = useState(fareCodeDefaultKey);
  const [isShowAccordion, setIsShowAccordion] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const copiedTimeout = useRef(null);

  useEffect(() => () => clearTimeout(copiedTimeout.current), []);

  const getSegmentCity = segment => {
    const departureTime = segment.departure.time;
    const departureCity = getCityName(included, language, segment.departure.city, segment.departure.airport);
    const arrivalCity = getCityName(included, language, segment.arrival.city, segment.arrival.airport);

    return [departureCity, arrivalCity, departureTime];
  };

  const getSegmentsCityList = () => {
    let data = [];

    _.forEach(routes, function (route) {
      _.forEach(route.segments, function (segment) {
        const [departureCity, arrivalCity, departureTime] = getSegmentCity(segment);
        const departureDateArray = departureTime.split(" ");
        const label = departureCity + " — " + arrivalCity + ", " + departureDateArray[0];
        const fareCode = segment.fare_code;

        data = [
          ...data,
          {
            value: fareCode + "|" + departureDateArray[0] + "|" + segment.index,
            label,
          },
        ];
      });
    });

    return data;
  };

  const segmentsList = getSegmentsCityList(routes, included, language);
  const segmentList = Object.keys(segmentsList).map(key => segmentsList[key]);

  const getSegmentPenalties = () => {
    const fareCode = _.first(fareCodeKey.split("|"));

    if (fareRules?.length > 0 && _.isString(fareCode)) {
      const fareRule = _.find(fareRules, { fare_code: fareCode });

      if (fareRule !== undefined) return fareRule.penalties;
    }

    return null;
  };

  const penalties = getSegmentPenalties();

  const getRulesContent = () => penalties ?? t("no_data_contact_technical_support");

  const handleCopyRules = async () => {
    // Копируем текст, а не разметку: агенты вставляют его в чат-бота целиком.
    const isDone = await copyToClipboard(htmlToPlainText(penalties));

    if (!isDone) return;

    setIsCopied(true);
    clearTimeout(copiedTimeout.current);
    copiedTimeout.current = setTimeout(() => setIsCopied(false), 2000);
  };

  const handleSelectSegment = value => {
    setFareCodeKey(value);
    // У другого сегмента свой текст — прежняя отметка «Скопировано» к нему не относится.
    clearTimeout(copiedTimeout.current);
    setIsCopied(false);
  };

  const onCloseRules = () => {
    handleCloseModal();
    setFareCodeKey(fareCodeDefaultKey);
  };

  return (
    <ModalComponent active={openModal} onClose={onCloseRules} title={t("tariff_rules")} fixedWidth>
      <Wrapper>
        <RulesAccordion>
          <RulesAccordionTitle>
            {t("how_to_read_rules")}
            <RulesAccordionToggleButton
              onClick={() => setIsShowAccordion(prev => !prev)}
              className={classNames({ active: isShowAccordion })}
            >
              <BiChevronDown />
            </RulesAccordionToggleButton>
          </RulesAccordionTitle>
          {isShowAccordion && (
            <RulesAccordionContent>
              <div>
                <p>
                  {t("rules_text_1")} <b>CANCELLATIONS ({t("cancel")}):</b>
                </p>
                <p>
                  <b>TICKET IS NON-REFUNDABLE</b> — {t("rules_text_2")};<br />
                  <b>TICKET IS NON-REFUNDABLE FOR CANCEL/REFUND</b> — {t("rules_text_2")};<br />
                  <b>REFUND IS NOT PERMITTED</b> — {t("rules_text_2")};<br />
                  <b>ANY TIME TICKET IS NON-REFUNDABLE</b> — {t("rules_text_2")};<br />
                  <b>TICKET IS NON-REFUNDABLE IN CASE OF NO-SHOW</b> — {t("rules_text_3")}.<br />
                </p>
                <p>
                  {t("rules_text_4")} <b>CHANGES.</b>
                </p>
                <p>
                  {t("line")} <b>CHANGES ARE NOT PERMITTED</b> {t("rules_text_5")}.
                </p>
              </div>
            </RulesAccordionContent>
          )}
        </RulesAccordion>

        <SelectRoutes>
          <SelectComponent value={fareCodeKey} options={segmentList} onSelect={handleSelectSegment} />
        </SelectRoutes>

        <RulesToolbar>
          <CopyRulesButton onClick={handleCopyRules} disabled={!penalties} $isCopied={isCopied}>
            {isCopied ? <BiCheck /> : <BiCopy />}
            {isCopied ? t("text_copied") : t("copy_text")}
          </CopyRulesButton>
        </RulesToolbar>

        <StyledPaper>
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(getRulesContent()) }} />
        </StyledPaper>
      </Wrapper>
    </ModalComponent>
  );
};

export default RulesModalComponent;
